// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"un6tn","rc-tabs-tab":"cMR81","rc-tabs-tab-active":"_8k1PS","tip":"YCosL","tip-label":"TRjaA","tip-group":"+lqmG","content":"HVYfL","footer":"K-uQ8"};